'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const react = require('@emotion/react');
const components_navigation_IconButton_BaseIconButton = require('./BaseIconButton.cjs.js');

function IconButton(_a) {
  var { color = "icon-primary", size = "small", tooltipPosition = "south" } = _a, props = tslib_es6.__rest(_a, ["color", "size", "tooltipPosition"]);
  return react.jsx(components_navigation_IconButton_BaseIconButton.BaseIconButton, Object.assign({ color, size, tooltipPosition }, props));
}

exports.IconButton = IconButton;
//# sourceMappingURL=IconButton.cjs.js.map
